module.exports = __webpack_public_path__ + "assets/overview-player.e83b1db3.svg";